import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { A11y, Navigation } from "swiper/modules"
// Swiper CSS comes from application.bootstrap.scss (swiper-bundle.min); importing
// it here makes esbuild emit its own application.css, clobbering the sass bundle.

// One instance per homepage best-sellers section; navigation is scoped to
// this.element so the two sections' arrows don't cross-wire.
export default class extends Controller {
  connect() {
    this.initSwiper()
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.element.querySelector('.swiper'), {
      modules: [A11y, Navigation],
      grabCursor: true,

      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 12
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 20
        }
      },

      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },

      a11y: {
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product',
      }
    })
  }
}
